import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowMolEvdListaEvidencijaHeader: React.FC<{
  datum: string;
  imePrezime: string;
  opis: string;
  izvrsioc: string;
  potpisIzvrsioca: string;
  potpisano: string;
  tackaEvidencije: string;
}> = ({
  datum,
  imePrezime,
  opis,
  izvrsioc,
  potpisIzvrsioca,
  potpisano,
  tackaEvidencije,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpisano}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{opis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{izvrsioc}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpisIzvrsioca}</Text>
    </View>
  </View>
);

export const TableRowMolEvdListaEvidencija: React.FC<{
  datum: string;
  imePrezime: string;
  opis: string;
  izvrsioc: string;
  potpisIzvrsioca: string;
  potpisano: string;
  tackaPrimjene: string;
}> = ({
  datum,
  imePrezime,
  opis,
  izvrsioc,
  potpisIzvrsioca,
  potpisano,
  tackaPrimjene,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpisano && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisano}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{izvrsioc}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpisIzvrsioca && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisIzvrsioca}
        />
      )}
    </View>
  </View>
);
